<template>
  <v-row
    class="ma-0 pa-0"
    v-if="allCategories.length"
    id="allCategories"
    flat
    color="transparent"
    justify="start"
  >
    <!--shopping list for mobile version (onTop)-->
    <v-col cols="12" class="px-0" v-if="isMobile">
      <div class="px-0 pt-3 pb-6">
        <h3 class="black--text homepageTitle">
          {{ $translate('MY_SHOPPING_LIST') }}
          <v-btn @click="handleGetShoppingLists()" color="secondary" class="secondary-font-color">
            <v-icon>mdi-refresh</v-icon>
            {{ $translate('REFRESH_SHOPPINGLISTS') }}
          </v-btn>
        </h3>
        <ShoppingListProfessionalView ref="shoppingListView" />
      </div>
    </v-col>

    <!-- categories and products-->
    <v-col
      cols="12"
      md="6"
      id="categoriesProfView"
      class="px-0 px-xs-0 pr-md-4 wrap-text"
    >
      <v-row class="ma-0">
        <v-col class="pa-0 pb-3 pl-2" cols="6" md="8" align-self="center">
          <h2 class="black--text homepageTitle">{{ title }}</h2>
        </v-col>
        <v-col class="pa-0" cols="6" md="4">
          <ProfessionalViewSelectList />
        </v-col>
      </v-row>
      <div v-for="(category,index)  in allCategories" v-if="!openCategory" class="pa-0 ma-0" :key="index">
        <ProfessionalViewSubCategory :sub-category="category"  @getShoppingLists="handleGetShoppingLists"></ProfessionalViewSubCategory>
      </div>
<!--      <div v-for="(category,index)  in allCategories" v-if="!openCategory" class="pa-0 ma-0" :key="index">-->
<!--        <v-card class="pa-0 pa-3">-->
<!--          <v-list class="wrap-text ma-0 pa-0">-->
<!--            <v-list-item  class="pa-0 pr-md-1" @click="viewCategory(category)">-->
<!--              <v-list-item-avatar>-->
<!--                <v-img-->
<!--                  max-width="50"-->
<!--                  max-height="50"-->
<!--                  :src="-->
<!--                      category.PictureUrl != null-->
<!--                        ? category.PictureUrl-->
<!--                        : category.Picture-->
<!--                    "-->
<!--                />-->
<!--              </v-list-item-avatar>-->
<!--              <v-list-item-content>-->
<!--                <v-list-item-title-->
<!--                  v-text="category.Name"-->
<!--                  class="homepageSubTitle"-->
<!--                >-->
<!--                </v-list-item-title>-->
<!--                <v-list-item-subtitle v-if="!isMobile">-->
<!--                    <span-->
<!--                      v-html="category.Description"-->
<!--                      class="primary&#45;&#45;text text-wrap text-body-1"-->
<!--                    ></span>-->
<!--                </v-list-item-subtitle>-->
<!--              </v-list-item-content>-->
<!--              <v-list-item-action>-->
<!--                <v-btn-->
<!--                  small-->
<!--                  color="secondary"-->
<!--                  class="pa-0 pa-2 secondary-font-color"-->
<!--                >  <v-icon> mdi-chevron-double-down</v-icon></v-btn>-->
<!--              </v-list-item-action>-->
<!--            </v-list-item></v-list>-->
<!--        </v-card>-->
<!--      </div>-->
<!--      <ProfessionalViewCategory :items="allCategories" v-if="openCategory" @close="closeOpenedCategory()"/>-->
<!--      <ProfessionalViewOrderNowBtn></ProfessionalViewOrderNowBtn>-->

    </v-col>

    <!-- vertical divider for non mobile screen-->
    <v-divider vertical v-if="!isMobile" />

    <!--shopping list for non-mobile version-->
    <v-col cols="12" md="6" v-if="!isMobile">
      <div class="px-0 py-3">
        <h3 class="black--text homepageTitle">
          {{ $translate('MY_SHOPPING_LIST') }}
          <v-btn @click="handleGetShoppingLists()" color="secondary" class="secondary-font-color ml-10">
            <v-icon>mdi-refresh</v-icon>
            {{ $translate('REFRESH_SHOPPINGLISTS') }}
          </v-btn>
        </h3>
        <ShoppingListProfessionalView ref="shoppingListView" />
      </div>
    </v-col>

  </v-row>
</template>
<script>
import { mapState } from 'vuex';
import { cloneDeep } from 'lodash';
import ProfessionalViewProduct from '@/components/event/professionalViewType/ProfessionalViewProduct';
import uiHelpers from '../../shared/ui_helpers';
import ProfessionalViewOrderNowBtn from '@/components/event/professionalViewType/ProfessionalViewOrderNowBtn';
import ShoppingListProfessionalView from '@/components/shoppingLists/ShoppingListProfessionalView';
import ProfessionalViewCategory from "@/components/event/professionalViewType/ProfessionalViewCategory.vue";
import ProfessionalViewSelectList from "@/components/event/professionalViewType/ProfessionalViewSelectList.vue";
import {scrollToElement} from "@/shared/utility";
import ProfessionalViewSubCategory from "@/components/event/professionalViewType/ProfessionalViewSubCategory.vue";

export default {
  name: 'ProfessionalViewCategories',
  mixins: [uiHelpers],
  props: {
    /**
     * Wrap items instead of overflowing to the right
     */
    wrap: Boolean,
  },
  components: {
    ProfessionalViewSubCategory,
    ProfessionalViewCategory,
    ProfessionalViewProduct,
    ProfessionalViewOrderNowBtn,
    ShoppingListProfessionalView,
    ProfessionalViewSelectList,
  },
  watch: {
    orders() {
      this.initOrders();
    },
  },
  mounted() {
    this.initOrders();
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    ...mapState('shoppingCart', {
      orders: (state) => state.orders,
    }),

    allCategories() {
      return this.$store.getters['user/productCategoriesWithProducts'];
    },

    pgrInfo() {
      return this.$store.getters['Account/partnerGroupDetails'];
    },

    title() {
      if (
        this.pgrInfo != null &&
        this.pgrInfo.ProductFocusTitle != null &&
        this.pgrInfo.ProductFocusTitle.trim() !== ''
      ) {
        return this.pgrInfo.ProductFocusTitle.trim();
      }
      return this.$translate('CATEGORIES_TITLE');
    },
  },
  data() {
    return {
      categoryId: 0,
      count: [],
      productsInCategoryCount: [],
      shoppingCart: [],
      productsInCart: [],
      openCategory: false,
      category: {},
    };
  },
  methods: {
    initOrders() {
      this.shoppingCart = [];
      if (this.orders.length > 0) {
        this.shoppingCart = cloneDeep(this.orders);
      } else {
        this.productsInCart = [];
      }
      if (this.shoppingCart.length > 0) {
        this.productsInCart = [];
        //this.productsInCart = this.shoppingCart[0].Products;
        this.shoppingCart.forEach((item) => {
          this.productsInCart.push(item.Products);
        });
        this.getProductCountInEachCategory();
      }
    },

    getCounterForCategory(categoryId) {
      let quantity = 0;

      if (this.productsInCategoryCount.length < 0)
        this.getProductCountInEachCategory();

      for (let i = 0; i < this.productsInCategoryCount.length; i++) {
        let obj = this.productsInCategoryCount[i];
        if (obj.categoryId === categoryId) {
          quantity += obj.quantity;
        }
      }
      return quantity;
    },

    getProductCountInEachCategory() {
      this.productsInCategoryCount = [];
      if (this.productsInCart.length > 0) {
        this.allCategories.forEach((category) => {
          category.Products.forEach((product) => {
            this.productsInCart.forEach((cartProduct) => {
              cartProduct.forEach((item) => {
                if (item.ProductId === product.Id) {
                  let tempProduct = {
                    categoryId: 0,
                    quantity: 0,
                  };

                  tempProduct.categoryId = category.Id;
                  if (item.ProductType !== 'Weighted') {
                    tempProduct.quantity += Number(item.Quantity);
                  } else {
                    tempProduct.quantity += 1;
                  }
                  this.productsInCategoryCount.push(tempProduct);
                }
              });
            });
          });
        });
      }
    },
    handleGetShoppingLists() {
      this.$refs.shoppingListView.getShoppingLists();
    },
    viewCategory(cat) {
      this.openCategory = true;
      this.category = cat;
    },
    closeOpenedCategory() {
      this.openCategory=false;
      scrollToElement('#categoriesProfView');
    }
  },
};
</script>
<style scoped lang="scss">
.add-btn {
  position: absolute;
  top: 2px;
  right: 2px;
}
.v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
  padding: 0px !important;
}
.expansion-panel-header {
  padding: 8px 8px 8px !important;
}
.wrap-text {
  //white-space: nowrap;
  white-space: normal;
  overflow-x: hidden;
  text-overflow: ellipsis;
}
</style>
